import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatDivider } from '@angular/material/divider';
import { MatFormField, MatLabel, MatSuffix, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { CartAmountValidator } from '@next/core-lib/cart';
import { AbstractDialog, AbstractDialogResultData, DIALOG_RETURN_TYPES, AgrDialogModule } from '@next/core-lib/dialog';
import { AgrFormModule } from '@next/core-lib/form';
import { LocaleService, AgrI18nSharedModule } from '@next/core-lib/i18n';

import { AddToCartDialogData } from '../../models/app.models';

@Component({
  selector: 'app-add-to-cart',
  templateUrl: './add-to-cart.component.html',
  styleUrls: ['./add-to-cart.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AgrDialogModule,
    MatDivider,
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    AgrFormModule,
    MatSuffix,
    NgIf,
    MatError,
    AgrI18nSharedModule,
  ],
})
export class AddToCartComponent extends AbstractDialog<AddToCartDialogData> implements OnInit {
  @ViewChild('quantityInput') quantityInput: ElementRef;

  formGroup = new FormGroup({
    quantity: new FormControl(),
  });

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: AddToCartDialogData,
    protected readonly mdDialogRef: MatDialogRef<AddToCartComponent, AbstractDialogResultData<AddToCartDialogData>>,
    private readonly localeService: LocaleService,
  ) {
    super();
  }

  ngOnInit() {
    this.formGroup.controls.quantity.setValue(this.data?.catalogItem?.orderingInformation?.minimumOrderUnitQuantity ?? 0);
    const validator = new CartAmountValidator(
      this.data?.catalogItem?.orderingInformation?.minimumOrderUnitQuantity,
      this.data?.catalogItem?.orderingInformation?.maximumOrderUnitQuantity,
      this.data?.catalogItem?.orderingInformation?.increaseOrderUnitQuantity,
      this.localeService,
    );
    this.formGroup.controls.quantity.setValidators([
      (control: AbstractControl) => validator.validate(control),
      Validators.min(this.data?.catalogItem?.orderingInformation?.minimumOrderUnitQuantity ?? 1),
      Validators.required,
      Validators.max(this.data?.catalogItem?.orderingInformation?.maximumOrderUnitQuantity),
    ]);

    setTimeout(() => {
      this.quantityInput.nativeElement.focus();
    }, 0);
  }

  confirm() {
    this.formGroup.updateValueAndValidity();

    if (this.formGroup.valid) {
      this.mdDialogRef.close({
        status: DIALOG_RETURN_TYPES.confirm,
        result: {
          catalogItem: this.data.catalogItem,
          quantity: this.formGroup.controls.quantity.value,
        },
      });
    }
  }

  cancel() {
    this.mdDialogRef.close({ status: DIALOG_RETURN_TYPES.cancel });
  }

  keyPress(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.confirm();
      event.preventDefault();
    }
  }
}
